import React from 'react'


/**
 * A button component with a label and customizable styles.
 * #registers
 *  #core
 * #devices
 * @param {string} label - The text to display on the button.
 * @param {object} props - Additional props to pass to the button element.
 * @returns {JSX.Element} - The button element.
 */
const AddButton = ({label, ...props}) => {
  return (
    <div 
    className='device-btn' 
    {...props}>
            <span className='device-btn-text'>{label}</span>                                               
    </div>
  )
}

export default AddButton
